export const CardHeaderDetalleEnvioStyles = 
{
  'header':{fontSize:14, 
    margin: '0px 0px 0px 0px', 
    color:'#6f6f71', 
    fontWeight:'bold' as 'bold'
   }
}
